module.exports = __webpack_public_path__ + "media/svgs/Ticket-Icon-da7b0a8d148959d432bb58ea08021d6e.svg";